module.exports = __webpack_public_path__ + "static/gem-personal-loans-tc-204e6790344a94916747ef5226b99792.png";